import React from "react";
import { createTravelCalendar, dayInTimeZone, shiftTravelDay, travelDayData } from "./travelZmanim";

/** Shared by the two Travel pages; astronomy remains owned by HebcalService. */
export default function useTravelZmanim(org) {
    const calendar = React.useMemo(() => createTravelCalendar(org), [
        org.lat, org.long, org.israel, org.zmanimShitat, org.chabadCandleLightingMinutes,
    ]);
    const timeZone = calendar?.getTimezone() || null;
    const [day, setDay] = React.useState(() => dayInTimeZone(new Date(), timeZone));
    React.useEffect(() => {
        setDay(dayInTimeZone(new Date(), timeZone));
    }, [org.id, timeZone]);
    const data = React.useMemo(() => travelDayData(calendar, day), [calendar, day]);
    const goDay = delta => setDay(current => shiftTravelDay(current, delta));
    return { ...data, day, timeZone, goDay };
}
